import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button, ModalLayout } from '@aimsos/ui';

/** Confirms leaving the create flow with unsaved input. */
function DiscardChangesModal({ isOpen, onKeepEditing, onDiscard }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onKeepEditing}
      title={t('create.discard.title')}
      titleId="discard-record-title"
      closeAriaLabel={t('create.discard.close')}
      maxWidthClassName="max-w-md"
      useBodyPortal
    >
      <p className="px-5 py-4 text-sm text-content-secondary">{t('create.discard.body')}</p>
      <div className="flex justify-end gap-3 border-t border-edge px-5 py-4">
        <Button variant="secondary" onClick={onKeepEditing}>
          {t('create.discard.keep')}
        </Button>
        <Button variant="danger" onClick={onDiscard}>
          {t('create.discard.confirm')}
        </Button>
      </div>
    </ModalLayout>
  );
}

export default memo(DiscardChangesModal);
